/**
 * shieldSatelliteConstants.ts
 * Tuning knobs for the World 2 `ShieldSatellite` — a sinusoidal-orbit
 * drifter with 3 HP. Split out of `spaceEnemyConstants.ts` so each
 * enemy kind owns its own constants file (Phase 5 Tech Debt — file
 * length cap split, see ROADMAP.md).
 *
 * Consumers should keep importing from `spaceEnemyConstants` — that
 * module re-exports every symbol here so the public surface is
 * unchanged.
 *
 * @module shieldSatelliteConstants
 */

/** Square-ish satellite hitbox. Distinct silhouette from fighter (36×28) and bomber (48×36). */
export const SHIELD_SATELLITE_WIDTH = 40;

/** Square-ish satellite hitbox. Distinct silhouette from fighter (36×28) and bomber (48×36). */
export const SHIELD_SATELLITE_HEIGHT = 40;

/** Three ship-projectile hits to kill — the tankiest non-boss enemy in the slice. */
export const SHIELD_SATELLITE_HP = 3;

/**
 * Horizontal drift relative to world space (px / s). Between fighter
 * (120) and bomber (60) so the satellite reads as "deliberate" rather
 * than fast or sluggish. Apparent on-screen velocity with the 80 px/s
 * auto-scroll is 160 px/s.
 */
export const SHIELD_SATELLITE_DRIFT_SPEED = 80;

/**
 * Sinusoidal vertical wobble amplitude in px. The satellite's distinguishing
 * kinematic feature — it drifts left while orbiting up/down around its spawn
 * Y. 30 px is enough to feel like a real orbit at the 64 px viewport scale
 * without ever pushing the satellite into the HUD strip or below the floor
 * margin (spawn-Y clamp already accounts for the full hitbox + this amplitude).
 */
export const SHIELD_SATELLITE_WOBBLE_AMPLITUDE = 30;

/**
 * Sinusoidal vertical wobble frequency in Hz. 0.5 Hz means a full
 * up-down-up cycle every 2 s — slow enough for the player to predict
 * the next pass, fast enough that the orbit reads as motion not drift.
 */
export const SHIELD_SATELLITE_WOBBLE_FREQUENCY_HZ = 0.5;
